import {computed, makeObservable, observable} from "mobx";

export class FileUploadFeature {
    constructor(singleFileMode = false, onFileChange = null, initialFiles = []) {
        this._files = [...initialFiles]
        this._fileError = ""
        this._loaded = false
        this._singleFileMode = singleFileMode
        this._onFileChange = onFileChange

        makeObservable(this, {
            _files: observable,
            _fileError: observable,
            _loaded: observable,
            _singleFileMode: observable,
            files: computed,
            fileError: computed,
            loaded: computed,
            singleFileMode: computed,
        });
    }

    get files() {
        return this._files;
    }

    set files(value) {
        this._files = value;
    }

    get fileError() {
        return this._fileError;
    }

    set fileError(value) {
        this._fileError = value;
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get singleFileMode() {
        return this._singleFileMode;
    }

    async load() {
        this.finishLoading();
    }

    finishLoading() {
        this._loaded = true;
    }

    acceptedFileTypes() {
        return ['.pdf', '.jpg', '.jpeg', '.png', '.docx'];
    }

    addFiles(newFiles) {
        const acceptedFileTypes = this.acceptedFileTypes();
        const validFiles = [];
        const invalidFiles = [];

        Array.from(newFiles).forEach(file => {
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
            if (acceptedFileTypes.includes(fileExtension)) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            this._fileError = `Solo se permiten archivos con las extensiones: ${acceptedFileTypes.join(', ')}`;
            return false;
        }

        if (this._singleFileMode && validFiles.length > 1) {
            this._fileError = `No se pueden seleccionar múltiples archivos. Solo se permite un único archivo.`;
            return false; 
        }

        this._fileError = "";
        
        if (this._singleFileMode) {
            this._files = validFiles;
        } else {
            this._files = [...this._files, ...validFiles];
        }
        
        if (this._onFileChange) {
            this._onFileChange(this._files);
        }
        
        return true;
    }

    removeFile(fileIndex) {
        this._files = this._files.filter((_, index) => index !== fileIndex);
        
        if (this._onFileChange) {
            this._onFileChange(this._files);
        }
    }

    removeAllFiles() {
        this._files = [];
        this._fileError = "";
        
        if (this._onFileChange) {
            this._onFileChange(this._files);
        }
    }

    hasFiles() {
        return this._files.length > 0;
    }

    getFileNames() {
        return this._files.map(file => file.name);
    }

    getFilesFormData() {
        const formData = new FormData();
        this._files.forEach((file, index) => {
            formData.append(`file_${index}`, file);
        });
        return formData;
    }
} 